module.exports = __webpack_public_path__ + "img/circle-light.c7c7b3fb.svg";